import { render, staticRenderFns } from "./ContractVersions.vue?vue&type=template&id=7bf0c5d7&"
import script from "./ContractVersions.vue?vue&type=script&lang=js&"
export * from "./ContractVersions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports